<template>
    <div class="modal right" tabindex="-1" role="dialog" id="exampleModalLong">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header p-2">
                        <h6 class="modal-title">{{$t('Parent description')}}</h6>
                        <button
                            class="close text-white"
                            data-dismiss="modal"
                            aria-label="Close"
                            v-on:click="closeDialog()"
                            title="Close"
                            >
                            <span aria-hidden="true">
                                <cancel-icon tabindex="0" class="close-icon categorybrowse" style="height: 30px !important;
                                    width: 30px !important;
                                    color: #fff;">
                                </cancel-icon>
                            </span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <!-- <div style="margin-bottom:6px;color: #8b8b8b;">Client Access Token</div> -->
                        <div v-if="fileInfo && fileInfo.metadata && fileInfo.metadata.description && fileInfo.metadata.description.length > 0" style="display: flex;justify-content: space-between;align-items: center;">
                            <div id="copy_the_text" style="cursor: text;pointer-events: all;user-select: text;margin-inline-end: 15px;white-space: pre-wrap">{{fileInfo.metadata.description}}</div>
                        </div>
                        <div v-else style="display: flex; justify-content: center; align-items: center;height:100%;width:100%;color:#757575">
                            {{$t('Empty description')}}
                        </div>
                    </div>
                        <div class="modal-footer p-0 primary-btn-style">
                            <button v-on:click="closeDialog()" data-dismiss="modal" class="btn btn-outline-secondary mr-2" style="height: 30px;padding: 0px 8px;">{{$t('Close')}}</button>
                        </div>
                </div>
            </div>
        </div>
</template>

<script>

import cancelIcon from "../core/InlineCancelField.vue"

export default {
    props:["fileInfo"],
    methods : {
        closeDialog(){
            this.$emit("closeDialog")
        },
    },
    components: {
        'cancel-icon':cancelIcon,
    },
}
</script>


<style lang="scss" scoped>
    $active-green-icon-color: #00ff3a;
    $count-bg-color:#e7c20b;
    $count-border-color:#373737;
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $panel-heading-font-size:18px;
    $secondary-border-color: 1px solid #2b2b2b;
    $widgets-bg-color: #202729;
    $widget-dropdown-color: #171717;
    $icon-hover:#2c3339;
    


.primary-btn-style{
    margin-top:1%;
    height:70px;
    display:inline-flex !important;
    flex-wrap: nowrap !important;
    button{
        height: 37px !important;
        border-radius: 5px;
        width: 70px;
    font-size:14px;
    float:inline-end;
    }
}

    /* width */
  ::-webkit-scrollbar {
    width: 8px;
    height:8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: $scrollbar-track-background !important;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background !important;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $bg-color-on-hover !important;
  }

    .modal-dialog {
        max-width: 600px;
        width: 600px;
        margin: 0;
        padding: 0;
    }

    .modal{
        transition: opacity .3s ease;
    }

    
    .modal-content {
        min-height: 100%;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
        background: $primary-background !important;
        border: $secondary-border-color;
        max-height: 100%;
        .modal-body{
            background: $primary-background;
            padding: 15px;
            height: 100%;
            overflow: auto;
        }
    }
    .modal-header,.modal-footer{
        border-top: $secondary-border-color !important;
        border-bottom: $secondary-border-color !important;
        background: $secondary-background-color;
        height: 58px;
        align-items: center;
        .modal-title{
            color:$text-color;
        }
    }

    .modal {
        text-align: center;
        padding: 0 !important;
        display: block;
        position: fixed;
        inset-inline-start: 0px;
        top: 10%;
        max-height: 75%;
    }
    .modal-header .close {
        margin: 0px !important;
        padding: 0px !important;
    }
    .modal:before {
        content: '';
        display: inline-block;
        height: 100vh;
        vertical-align: middle;
        margin-inline-end: -4px;
        position: fixed;
        width: 100vw;
        inset-inline-start: 0;
        top: 0;
        background: #00000094;
    }
    .modal-dialog {
        display: inline-block;
        text-align: start;
        vertical-align: middle;
        height: 100%;
    }

    .close-icon:hover{
        background: $icon-hover;
        border-radius: 20px;
    }

</style>